export function collaborativeEditing() {
	// NOOP intentionally blank
}

export function collaborativeEditingWRM() {
	return [
		'wr!com.atlassian.confluence.plugins.confluence-collaborative-editor-plugin:confluence-collaborative-editor-plugin-resources',
	];
}
